// GallerySection.jsx
// (Optional fonts for best match – put in index.html)
// <link rel="preconnect" href="https://fonts.googleapis.com" />
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
// <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@700;800&family=DM+Sans:wght@400;500&display=swap" rel="stylesheet" />

import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import Img1 from "../../../Assets/Gallery/gallery1.png";
import Img2 from "../../../Assets/Gallery/gallery2.png";
import Img3 from "../../../Assets/Gallery/gallery3.png";
import Img4 from "../../../Assets/Gallery/gallery4.png";
import Img5 from "../../../Assets/Gallery/gallery5.png";
import Img6 from "../../../Assets/Gallery/gallery6.png";
import Img7 from "../../../Assets/Gallery/gallery7.png";
import Img8 from "../../../Assets/Gallery/gallery8.png";

const galleryItems = [
  
    {
    src: Img3,
    category: "Water Mitigation",
    title: "Emergency Water Extraction",
  },
    {
    src: Img5,
    category: "Cleaning Services",
    title: "Deep Home Cleaning",
  },
  {
    src: Img1,
    category: "HVAC Services",
    title: "AC Installation & Maintenance",
  },
   {
    src: Img7,
    category: "Roofing Services",
    title: "Roof Inspection & Repair",
  },
  {
    src: Img2,
    category: "HVAC Services",
    title: "Heating System Repair",
  },
   {
    src: Img6,
    category: "Cleaning Services",
    title: "Office & Commercial Cleaning",
  },
  {
    src:Img4,
    category: "Water Mitigation",
    title: "Flood Damage Restoration",
  },

 {
    src: Img8,
    category: "Roofing Services",
    title: "Shingle Replacement & Installation",
  }
];

const GallerySection = () => (
  <>
    <style>{`
      :root {
        --gallery-bg: url("https://html.themehour.net/kleanix/demo/assets/img/bg/gallery-bg-3.jpg");
        --gallery-accent: #7ac142;
        --gallery-heading: #111827;
        --gallery-text: #6b7280;
        --gallery-card-radius: 40px;
        --gallery-card-shadow: 0 28px 80px rgba(15, 23, 42, 0.08);
        --gallery-font-heading: "Archivo", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        --gallery-font-body: "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        --gallery-ease: cubic-bezier(0.16, 1, 0.3, 1);
      }

      .gallery-section {
        position: relative;
        padding: 96px 16px 96px;
        background-image: var(--gallery-bg);
        background-size: cover;
        background-position: center;
        overflow: hidden;
      }

      .gallery-inner {
        max-width: 1200px;
        margin: 0 auto;
      }

      /* Heading */
      .gallery-heading-wrap {
        text-align: center;
        margin-bottom: 40px;
      }

      .gallery-kicker-wrap {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
      }

      .gallery-kicker-line {
        width: 44px;
        height: 2px;
        border-radius: 999px;
        background: var(--gallery-accent);
      }

      .gallery-kicker {
        font-family: var(--gallery-font-body);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: var(--gallery-accent);
      }

      .gallery-title {
        font-family: var(--gallery-font-heading);
        font-weight: 800;
        font-size: 34px;
        line-height: 1.2;
        color: var(--gallery-heading);
        margin: 0;
      }

      /* Grid */
      .gallery-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 32px;
        justify-items: center;
      }

      .gallery-card {
        width: 100%;
        max-width: 380px;
      }

      .gallery-img-wrap {
        position: relative;
        border-radius: var(--gallery-card-radius);
        overflow: hidden;
        box-shadow: var(--gallery-card-shadow);
        cursor: pointer;
        background-color: #ffffff;
        transition: transform 220ms var(--gallery-ease), box-shadow 220ms var(--gallery-ease);
      }

      .gallery-img-inner {
        position: relative;
        width: 100%;
        aspect-ratio: 4 / 3;
        overflow: hidden;
      }

      .gallery-img-inner img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 260ms var(--gallery-ease);
      }

     .gallery-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 18px 22px 22px;
  background: linear-gradient(
    to top,
    rgba(15, 23, 42, 0.86),
    rgba(15, 23, 42, 0.35),
    transparent 55%
  );
  color: #ffffff;

  /* make always visible */
  opacity: 1;
  transform: translate3d(0, 0, 0);
}


.gallery-img-wrap:hover .gallery-overlay {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}


      .gallery-category {
        font-family: var(--gallery-font-body);
        font-size: 13px;
        opacity: 0.9;
        margin-bottom: 2px;
      }

      .gallery-item-title {
        font-family: var(--gallery-font-heading);
        font-size: 18px;
        font-weight: 700;
      }

      .gallery-icon-btn {
        position: absolute;
        right: 22px;
        top: 20px;
        width: 42px;
        height: 42px;
        border-radius: 999px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #111827;
        box-shadow: 0 16px 30px rgba(15, 23, 42, 0.35);
        opacity: 0;
        transform: translate3d(0, -10px, 0);
        transition: opacity 220ms var(--gallery-ease), transform 220ms var(--gallery-ease), background-color 220ms var(--gallery-ease), color 220ms var(--gallery-ease);
      }

      .gallery-img-wrap:hover {
        transform: translate3d(0, -6px, 0);
        box-shadow: 0 40px 100px rgba(15, 23, 42, 0.18);
      }

      .gallery-img-wrap:hover .gallery-img-inner img {
        transform: scale(1.05);
      }

      .gallery-img-wrap:hover .gallery-overlay {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }

      .gallery-img-wrap:hover .gallery-icon-btn {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        background-color: var(--gallery-accent);
        color: #ffffff;
      }

      /* Responsive */
      @media (max-width: 1199px) {
        .gallery-section {
          padding-top: 80px;
          padding-bottom: 80px;
        }
        .gallery-title {
          font-size: 30px;
        }
      }

      @media (max-width: 959px) {
        .gallery-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      @media (max-width: 599px) {
        .gallery-section {
          padding-top: 64px;
          padding-bottom: 64px;
        }
        .gallery-title {
          font-size: 24px;
        }
        .gallery-grid {
          grid-template-columns: 1fr;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .gallery-img-wrap,
        .gallery-img-inner img,
        .gallery-overlay,
        .gallery-icon-btn {
          transition: none !important;
        }
      }
    `}</style>

    <Box component="section" className="gallery-section">
      <Container className="gallery-inner">
        {/* Heading */}
        <Box className="gallery-heading-wrap">
          <Box className="gallery-kicker-wrap">
            <Box className="gallery-kicker-line" />
            <Typography className="gallery-kicker">WORK GALLERY</Typography>
            <Box className="gallery-kicker-line" />
          </Box>
          <Typography component="h2" className="gallery-title">
            Our Work Gallery That We Do!
          </Typography>
        </Box>

        {/* Grid */}
        <Box className="gallery-grid">
          {galleryItems.map((item, idx) => (
            <Box key={idx} className="gallery-card">
              <Box className="gallery-img-wrap">
                <Box className="gallery-img-inner">
                  <img src={item.src} alt={item.title} />
                  <button
                    type="button"
                    className="gallery-icon-btn"
                    aria-label={`View details for ${item.title}`}
                  >
                    <ArrowForwardRoundedIcon fontSize="small" />
                  </button>

                  <Box className="gallery-overlay">
                    <Typography className="gallery-category">
                      {item.category}
                    </Typography>
                    <Typography className="gallery-item-title">
                      {item.title}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  </>
);

export default GallerySection;
